import { Buffer } from 'buffer'
import zlib from 'zlib'
import localForage from 'localforage'
// const logger = require('debug')('lib:storage')
// const logger = (...args) => console.debug('lib:storage:', ...args)

const Encode = (object = {}) =>
  new Promise((resolve, reject) => {
    const plaintext = JSON.stringify(object)
    zlib.gzip(plaintext, function (err, buf) {
      const buffer = Buffer.from(buf)
      const b64 = buffer.toString('base64')
      // logger(`plaintext_size: ${plaintext.length}; gzipped_size: ${buffer.length}; base64_size: ${b64.length}`)
      if (err) reject(err)
      else resolve(b64)
    })
  })

const Decode = b64String =>
  new Promise((resolve, reject) => {
    zlib.gunzip(Buffer.from(b64String, 'base64'), function (err, buf) {
      if (err) reject(err)
      else resolve(JSON.parse(buf.toString()))
    })
  })

const stores = {}
const Store = name => {
  if (!name || !name.length) return null
  if (stores[name]) return stores[name]
  stores[name] = localForage.createInstance({ name })
  return stores[name] || null
}

const Dummy = () => new Promise(resolve => resolve())

// Encode() is async. It must be awaited: only localForage's IndexedDB driver adopts a
// thenable passed to setItem — the localStorage fallback hands it straight to the
// serializer, which stores a bare "{}" that every later Decode() then fails on.
export const SetData = async (storeName, key, value) => {
  const store = Store(storeName)
  return null != store ? store.setItem(key, await Encode(value)) : Dummy()
}
export const GetData = (storeName, keys) => {
  const store = Store(storeName)
  return null != store
    ? Promise.all(keys.map(key => store.getItem(key).then(data => (data ? Decode(data) : data))))
    : Dummy()
}
export const GetDataByKey = (storeName, key) => {
  const store = Store(storeName)
  return null != store ? store.getItem(key).then(data => (data ? Decode(data) : data)) : Dummy()
}
export const ClearData = (storeName, keys) => {
  const store = Store(storeName)
  return null != store ? Promise.all(keys.map(key => store.removeItem(key))) : Dummy()
}
export const DataKeys = storeName => {
  const store = Store(storeName)
  return null != store ? store.keys() : Dummy()
}

export const Storage = {
  Encode,
  Decode,
  Store,
  ClearData,
  DataKeys,
  GetDataByKey,
  GetData,
  SetData,
  Dummy
}

if ('undefined' !== typeof window && !window['$STRG']) {
  window['$STRG'] = Object.assign({}, Storage)
}
